(ns dre.components.widget.views
  (:require
   ["antd" :refer [Spin]]
   [dre.app.events :as-alias app]
   [dre.components.widget.views.content :as content]
   [dre.components.widget.views.content-header :as c-header] 
   [dre.components.widget.views.content-footer :as c-footer]
   [dre.components.widget.views.header :as header]
   [dre.i18n.events :as-alias i18n]
   [dre.utils.bem :as bem-utils]
   [re-frame.core :as rf]))

(def component-name :widget)

(defn view
  ([id title content widget-menu-opts widget-opts]
   (view id title content nil nil widget-menu-opts widget-opts))
  ([id title content content-header content-footer widget-menu-opts widget-opts]
   (let [{:keys [loading? loading-tip]} widget-opts]
     (if loading?
       [:div
        {:class [component-name (when id (bem-utils/be component-name id))]}
        [header/view id title widget-menu-opts]
        (if loading-tip
          [:> Spin
           {:tip @(rf/subscribe [::i18n/translate loading-tip])}
           [:span]]
          [:> Spin])
        [:div {:class ["widget-rgl-header" "widget-rgl-top"]}]
        [:div {:class ["widget-rgl-header" "widget-rgl-bottom"]}]
        [:div {:class ["widget-rgl-header" "widget-rgl-left"]}]
        [:div {:class ["widget-rgl-header" "widget-rgl-right"]}]]
       [:div
        {:class [component-name (when id (bem-utils/be component-name id))]}
        [header/view id title widget-menu-opts]
        (when content-header
          [c-header/view content-header])
        [content/view id content]
        (when content-footer
          [c-footer/view content-footer])
        [:div {:class ["widget-rgl-header" "widget-rgl-top"]}]
        [:div {:class ["widget-rgl-header" "widget-rgl-bottom"]}]
        [:div {:class ["widget-rgl-header" "widget-rgl-left"]}]
        [:div {:class ["widget-rgl-header" "widget-rgl-right"]}]]))))
